import React, { useState } from 'react';
import AdminSidebar from '../components/AdminSidebar.js';
import AdminUsers from '../components/AdminUsers.js';
import AdminReservations from '../components/AdminReservations.js';
import AdminSubjects from '../components/AdminSubjects.js';
import AdminChat from '../components/AdminChat.js';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="admin-dashboard">
      <AdminSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="content section-header">
        {activeTab === 'users' && <AdminUsers activeTab={activeTab} />}
        {activeTab === 'reservations' && <AdminReservations activeTab={activeTab} />}
        {activeTab === 'subjects' && <AdminSubjects activeTab={activeTab} />}
        {activeTab === 'chat' && <AdminChat activeTab={activeTab} />}
      </div>
    </div>
  );
};

export default AdminDashboard;